/**
 * Globalny przełącznik redesignu (Wise UI): wszystkie nowe widoki mockupów vs legacy.
 * Ustaw w `.env`: REACT_APP_WISE_UI=true lub 1 (wartość wbudowywana przy buildzie).
 */
export const isWiseUiEnabled = (): boolean => {
  const v = process.env.REACT_APP_WISE_UI;
  return v === 'true' || v === '1';
};
